/**
 * Serializable intent for `RouteAssistantMessage` after a successful send.
 * Callbacks cannot be stored in web history state (`pushState`).
 */
export const ASSISTANT_MESSAGE_POST_SUBMIT_INTENTS = {
  /** Open the new support case thread or assistant messages tab (default). */
  NAVIGATE_TO_SUPPORT_CASE: 'navigate_to_support_case',
  /** Pop the stack once (e.g. return to checkout / parent sheet). */
  GO_BACK: 'go_back',
} as const;

export type AssistantMessagePostSubmitIntent =
  (typeof ASSISTANT_MESSAGE_POST_SUBMIT_INTENTS)[keyof typeof ASSISTANT_MESSAGE_POST_SUBMIT_INTENTS];
